
class CardActive {
 	 [x: string]: any;
 	 static $inject = ['Card','Toast','CardService'];
    constructor(Card, Toast, CardService) {
        this.Card = Card;
        this.toast = Toast;
        this.CardService = CardService;
    }

    changeCard() {
        this.CardService.changeCard();
    }
}

export default {
    controller: CardActive,
    template : require('./card.active.html'),
    bindings: {active: "<", cardChanged: "&"}
};
